<nav class="detail-nav" *ngIf="showTabs">
  <a routerLinkActive="active" [routerLink]="tabLink('participants')">Participants</a>
  <a routerLinkActive="active" [routerLink]="tabLink('overview')">Overview</a>
  <a routerLinkActive="active" [routerLink]="tabLink('sponsors')" *ngIf="!hideContestTabs">Sponsors</a>
  <a routerLinkActive="active" [routerLink]="tabLink('judges')" *ngIf="!hideContestTabs">Judges</a>
  <a routerLinkActive="active" [routerLink]="tabLink('prizes')" *ngIf="!hideContestTabs">Prizes</a>
  <a routerLinkActive="active" [routerLink]="tabLink('teams')">Teams</a>
  <a routerLinkActive="active" [routerLink]="tabLink('submissions')">Submissions</a>
  <a routerLinkActive="active" [routerLink]="tabLink('schedule')" *ngIf="!hideContestTabs">Schedule</a>
  <a routerLinkActive="active" [routerLink]="tabLink('preview')">Preview</a>
</nav>

<router-outlet></router-outlet>
